import React, { Component } from 'react';
import _ from 'lodash';
import { RadioButtonGroup } from 'components';
import { connect } from 'react-redux';
import * as actions from 'state/modules/popup';
import Dropdown from 'react-toolbox/lib/dropdown';
import moment from 'moment';
import Input from 'react-toolbox/lib/input';
import Dialog from 'react-toolbox/lib/dialog';
import styles from './PopupEdit.css';

const debug = _debug('app:PopupEdit');

class PopupEdit extends Component {
  static propTypes = {
    closeAction: React.PropTypes.func,
    updateContactAction: React.PropTypes.func,
    fetchContactData: React.PropTypes.func,
    currentLanguage: React.PropTypes.strings,
    wholeData: React.PropTypes.objectOf(React.PropTypes.shape({})),
    strings: React.PropTypes.objectOf(React.PropTypes.shape({})),
    picklistLanguage: React.PropTypes.objectOf(React.PropTypes.shape({})),
  }

  constructor(props) {
    super(props);
    debug(this.state.editRadioValue);
    this.optionSetLanguage = this.props.picklistLanguage;
  }
  state = {
    firstNameValue: '',
    lastNameValue: '',
    phoneNumberValue: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    businessFirmName: '',
    editDropdownValue: '',
    editRadioValue: '',
    comments: '',
    active: false,
    errorMessage: '',
    dbData: '',
    emailaddress: '',
    langindicator: ''
  };
  componentWillMount() {
    const promised = this.props.fetchContactData(this.props.wholeData.id);
    promised.then((response) => {
      if (response) {
        this.setState({ dbData: response });
        if (response.lastname) {
          const nameString = response.lastname.trim();
          const name = nameString.split(' ');
          let firstName = '';
          for (let x = 0; x < name.length - 1; x += 1) {
            firstName += ` ${name[x]}`;
          }
          const lastName = name[name.length - 1];
          this.setState({ firstNameValue: firstName });
          this.setState({ lastNameValue: lastName });
        }
        if (response.cica_comments) {
          this.setState({ comments: response.cica_comments });
        }
        if (response.cica_dob) {
          this.setState({ DOB: moment(response.cica_dob).format('MM/DD/YYYY') });
        }
        if (response.emailaddress1) {
          this.setState({ emailaddress: response.emailaddress1 });
        }
        if (response.cica_occupation) {
          this.setState({ occupation: response.cica_occupation });
        }
        if (response.cica_langindicator) {
          this.setState({ langindicator: parseInt(response.cica_langindicator, 10) });
        }
        if (response.cica_pcname) {
          this.setState({ pcname: response.cica_pcname });
        }
        if (response.cica_calltype) {
          if (response.cica_calltype === 1 || response.cica_calltype === '1') {
            this.setState({ editRadioValue: '1' });
            this.setState({ address: response.address2_line1 });
            this.setState({ city: response.address2_city });
            this.setState({ state: response.address2_stateorprovince });
            this.setState({ zip: response.address2_postalcode });
            this.setState({ businessFirmName: response.companyname });
          } else if (response.cica_calltype === 2 || response.cica_calltype === '2') {
            this.setState({ editRadioValue: '2' });
            this.setState({ address: response.address1_line1 });
            this.setState({ city: response.address1_city });
            this.setState({ state: response.address1_stateorprovince });
            this.setState({ zip: response.address1_postalcode });
          }
        }
        if (response.cica_phonenumbertype) {
          if (response.cica_phonenumbertype === '1') {
            this.phoneNumberAction(response.address1_telephone1);
            this.setState({ editDropdownValue: '1' });
          } else if (response.cica_phonenumbertype === '2') {
            this.phoneNumberAction(response.address2_telephone1);
            this.setState({ editDropdownValue: '2' });
          } else if (response.cica_phonenumbertype === '3') {
            this.phoneNumberAction(response.address1_telephone2);
            this.setState({ editDropdownValue: '3' });
          } else {
            this.setState({ phoneNumberValue: '' });
          }
        } else if (response.address1_telephone1) {
          this.phoneNumberAction(response.address1_telephone1);
          this.setState({ editDropdownValue: '1' });
        } else if (response.address2_telephone1) {
          this.phoneNumberAction(response.address2_telephone1);
          this.setState({ editDropdownValue: '2' });
        } else if (response.address1_telephone2) {
          this.phoneNumberAction(response.address1_telephone2);
          this.setState({ editDropdownValue: '3' });
        } else {
          this.setState({ phoneNumberValue: '' });
        }
      } else {
      // response is undefined/null
      }
    }, errorResponse => debug(errorResponse));
  }
  optionSetLanguage = [];
  handleToggle = () => {
    this.setState({ active: !this.state.active });
  }
  lastNameCallback = (value) => {
    this.setState({ lastNameValue: value });
  };
  firstNameCallback = (value) => {
    this.setState({ firstNameValue: value });
  };
  phoneNumberAction = (phoneNumberData) => {
    let phoneNumber = phoneNumberData;
    if (phoneNumber.length < 13) {
      phoneNumber = phoneNumber.replace(/[^\d]/g, '');
      if (phoneNumber.length > 3) {
        phoneNumber = this.insertInNumber(phoneNumber, 3, '-');
        if (phoneNumber.length > 7) {
          phoneNumber = this.insertInNumber(phoneNumber, 7, '-');
          if (phoneNumber.length > 13) {
            phoneNumber = this.insertInNumber(phoneNumber, 13, '-');
          }
        }
      }
      this.setState({ phoneNumberValue: phoneNumber });
    }
  };
  insertInNumber = (s1, index, s2) => {
    const substr = s1.substring(0, index) + s2 + s1.substring(index);
    return substr;
  }
  action = strings => [
    { label: strings.ok, onClick: this.handleToggle }
  ];

  addressAction = (value) => {
    this.setState({ address: value });
  };
  cityChangedAction = (value) => {
    this.setState({ city: value });
  };
  stateChangedAction = (value) => {
    this.setState({ state: value });
  };
  zipChangedAction = (value) => {
    this.setState({ zip: value });
  };
  businessFirmAction = (value) => {
    this.setState({ businessFirmName: value });
  };
  commentsAction = (value) => {
    this.setState({ comments: value });
  };
  handleEditDropdownChange = (value) => {
    this.setState({ editDropdownValue: value });
    if (value === 1 || value === '1') {
      this.phoneNumberAction(this.state.dbData.mobilephone ? this.state.dbData.mobilephone : '');
    } else if (value === 2 || value === '2') {
      this.phoneNumberAction(this.state.dbData.address2_telephone1 ? this.state.dbData.address2_telephone1 : '');
    } else if (value === 3 || value === '3') {
      if (this.state.dbData.address1_telephone1) {
        this.phoneNumberAction(this.state.dbData.address1_telephone1 ? this.state.dbData.address1_telephone1 : '');
      }
    }
  };
  editRadioChange = (value) => {
    this.setState({ editRadioValue: value });
    // on change of calltype change the value of the textfields also
    if (value === 1 || value === '1') {
      this.setState({ address: this.state.dbData.address2_line1 ? this.state.dbData.address2_line1 : '' });
      this.setState({ city: this.state.dbData.address2_city ? this.state.dbData.address2_city : '' });
      this.setState({ state: this.state.dbData.address2_stateorprovince ? this.state.dbData.address2_stateorprovince : '' });
      this.setState({ zip: this.state.dbData.address2_postalcode ? this.state.dbData.address2_postalcode : '' });
    } else {
      this.setState({ address: this.state.dbData.address1_line1 ? this.state.dbData.address1_line1 : '' });
      this.setState({ city: this.state.dbData.address1_city ? this.state.dbData.address1_city : '' });
      this.setState({ state: this.state.dbData.address1_stateorprovince ? this.state.dbData.address1_stateorprovince : '' });
      this.setState({ zip: this.state.dbData.address1_postalcode ? this.state.dbData.address1_postalcode : '' });
    }
  };
  dobChangeAction = (dobData) => {
    let dob = dobData;
    if (dob.length < 11) {
      dob = dob.replace(/[^\d]/g, '');
      if (dob.length > 2) {
        dob = this.insertInNumber(dob, 2, '/');
        if (dob.length > 5) {
          dob = this.insertInNumber(dob, 5, '/');
        }
      }
      this.setState({ DOB: dob });
    }
  };
  handleLanguageChange = (value) => {
    this.setState({ langindicator: value });
  }
  handleBestTimeToCall = (value) => {
    this.setState({ bestTimeToCall: value });
  }
  emailChange = (value) => {
    this.setState({ emailaddress: value });
  }
  pcChange = (value) => {
    this.setState({ pcname: value });
  }
  translatedData = (preprocessedData) => {
    const translatorTemplate = {
      lastname: 'Lead Name',
      cica_calltype: 'Call Type',
      address1_telephone1: 'Residential Phone',
      address2_telephone1: 'Business Phone',
      address1_telephone2: 'Alternate Phone',
      emailaddress1: 'Email address',
      cica_langindicator: 'Language',
      companyname: 'Firm Name',
      cica_pcname: 'Primary Contact',
      cica_comments: 'Comments',
      cica_dob: 'DOB',
      resAddress: 'Residential Address',
      busAddress: 'Business Address',
    };
    if (preprocessedData.cica_calltype) {
      preprocessedData.cica_calltype = (preprocessedData.cica_calltype === '1' || preprocessedData.cica_calltype === 1) ? 'B' : 'R'; // eslint-disable-line
    }
    if (preprocessedData.cica_langindicator) {
      preprocessedData.cica_langindicator = (preprocessedData.cica_langindicator === '1'|| preprocessedData.cica_langindicator === 1) ? 'E' : 'S'; // eslint-disable-line
    }
    const updatedTranslatedData = {};
    Object.keys(preprocessedData).forEach((key) => {
      const keyUpdate = translatorTemplate[key] ? translatorTemplate[key] : null;
      if (keyUpdate != null) {
        updatedTranslatedData[keyUpdate] = preprocessedData[key];
      }
    });
    return updatedTranslatedData;
  };
  saveContactData = () => {
    const dbData = this.state.dbData;
    const strings = this.props.strings;
    const firstName = this.state.firstNameValue.trim();
    const lastName = this.state.lastNameValue.trim();
    const name = `${firstName} ${lastName}`;
    const phoneNumberValue = this.state.phoneNumberValue ?
    this.state.phoneNumberValue.replace(/[^\d]/g, '') : this.state.phoneNumberValue;
    const phoneNumberType = this.state.editDropdownValue;
    let callType = '';
    if (this.state.editRadioValue && this.state.editRadioValue !== '') {
      callType = parseInt(this.state.editRadioValue, 10);
    }
    let isNumberEntered = false;
    let contactData = '';
    let addr1Line1 = '';
    let addr1City = '';
    let addr1Stateorprovince = '';
    let addr1Postalcode = '';
    let addr2Line1 = '';
    let addr2City = '';
    let addr2Stateorprovince = '';
    let addr2Postalcode = '';

    if (phoneNumberValue !== '') {
      isNumberEntered = true;
    }
    if (callType === 1) { // Business
      addr2Line1 = this.state.address;
      addr2City = this.state.city;
      addr2Stateorprovince = this.state.state;
      addr2Postalcode = this.state.zip;
    } else if (callType === 2) { // Residence
      addr1Line1 = this.state.address;
      addr1City = this.state.city;
      addr1Stateorprovince = this.state.state;
      addr1Postalcode = this.state.zip;
    }
    if (firstName && isNumberEntered && phoneNumberType) {
      contactData = {
        lastname: name,
        cica_calltype: callType,
        cica_comments: this.state.comments,
        cica_assigneddate: dbData.cica_assigneddate ? dbData.cica_assigneddate : `${moment().utc().format('YYYY-MM-DDTHH:mm:ss')}Z`,
        cica_phonenumbertype: phoneNumberType,
        cica_dob: this.state.DOB,
        emailaddress1: this.state.emailaddress,
        cica_occupation: this.state.occupation,
        cica_langindicator: this.state.langindicator,
        cica_pcname: this.state.pcname
      };
      if (phoneNumberType === '1' || phoneNumberType === 1) {
        contactData.address1_telephone1 = phoneNumberValue;
      } else if (phoneNumberType === '2' || phoneNumberType === 2) {
        contactData.address2_telephone1 = phoneNumberValue;
      } else if (phoneNumberType === '3' || phoneNumberType === 3) {
        contactData.address1_telephone2 = phoneNumberValue;
      }
      if (callType === 1) {
        contactData.address2_line1 = addr2Line1;
        contactData.address2_city = addr2City;
        contactData.address2_stateorprovince = addr2Stateorprovince;
        contactData.address2_postalcode = addr2Postalcode;
        contactData.companyname = this.state.businessFirmName ? this.state.businessFirmName : '';
      } else {
        contactData.address1_line1 = addr1Line1;
        contactData.address1_city = addr1City;
        contactData.address1_stateorprovince = addr1Stateorprovince;
        contactData.address1_postalcode = addr1Postalcode;
      }
      if (this.props.wholeData.isPersonal) {
        if (callType === 1) {
          contactData.cica_pcstreet = addr2Line1;
          contactData.cica_pccity = addr2City;
          contactData.cica_pccounty = addr2Stateorprovince;
          contactData.cica_pczip = addr2Postalcode;
        } else {
          contactData.cica_pcstreet = addr1Line1;
          contactData.cica_pccity = addr1City;
          contactData.cica_pccounty = addr1Stateorprovince;
          contactData.cica_pczip = addr1Postalcode;
        }
      }
      if (!this.props.wholeData.isPersonal) {
        const updatedJSON = {};
        Object.keys(contactData).forEach((key) => {
          if (key !== 'cica_dob') {
              // condition added so that the empty values must not get pushed,
              // as we are getting null from CRM and setting it to blank
              if (contactData[key] != dbData[key] && (dbData[key] != null || contactData[key] != '') ){ //eslint-disable-line
                updatedJSON[key] = contactData[key];
              }
          } else if (moment(dbData[key]).format('MM-DD-YYYY') != moment(contactData[key]).format('MM-DD-YYYY')) { //eslint-disable-line
            updatedJSON[key] = contactData[key];
          }
        });
        let addressUpdate = false;
        if (updatedJSON.address2_line1 || updatedJSON.address2_city
          || updatedJSON.address2_stateorprovince || updatedJSON.address2_postalcode) {
          addressUpdate = true;
        }
        if (updatedJSON.address1_line1 || updatedJSON.address1_city
          || updatedJSON.address1_stateorprovince || updatedJSON.address1_postalcode) {
          addressUpdate = true;
        }

        if ((contactData.cica_calltype === '1' || contactData.cica_calltype === 1) && addressUpdate) {
          updatedJSON.busAddress = '';
          updatedJSON.busAddress += updatedJSON.address2_line1 ?
            updatedJSON.address2_line1 : contactData.address2_line1;
          updatedJSON.busAddress += updatedJSON.address2_city ?
            ` ${updatedJSON.address2_city}` : ` ${contactData.address2_city}`;
          updatedJSON.busAddress += updatedJSON.address2_stateorprovince ?
            ` ${updatedJSON.address2_stateorprovince}` : ` ${contactData.address2_stateorprovince}`;
          updatedJSON.busAddress += updatedJSON.address2_postalcode ?
            ` ${updatedJSON.address2_postalcode}` : ` ${contactData.address2_postalcode}`;

          delete updatedJSON.address2_line1;
          delete updatedJSON.address2_city;
          delete updatedJSON.address2_stateorprovince;
          delete updatedJSON.address2_postalcode;
        }
        if ((contactData.cica_calltype === '2' || contactData.cica_calltype === 2) && addressUpdate) {
          updatedJSON.resAddress = '';
          updatedJSON.resAddress += updatedJSON.address1_line1 ?
            updatedJSON.address1_line1 : contactData.address1_line1;
          updatedJSON.resAddress += updatedJSON.address1_city ?
            ` ${updatedJSON.address1_city}` : ` ${contactData.address1_city}`;
          updatedJSON.resAddress += updatedJSON.address1_stateorprovince ?
            ` ${updatedJSON.address1_stateorprovince}` : ` ${contactData.address1_stateorprovince}`;
          updatedJSON.resAddress += updatedJSON.address1_postalcode ?
            ` ${updatedJSON.address1_postalcode}` : ` ${contactData.address1_postalcode}`;

          delete updatedJSON.address1_line1;
          delete updatedJSON.address1_city;
          delete updatedJSON.address1_stateorprovince;
          delete updatedJSON.address1_postalcode;
        }
        const updatedRealData = this.translatedData(updatedJSON);
        dbData.cica_leadjson = JSON.stringify(updatedRealData);
        dbData.id = this.props.wholeData.id;
        this.props.updateContactAction(dbData);
      } else {
        Object.keys(contactData).forEach((key) => {
          dbData[key] = contactData[key];
        });
        // Update the current db data back so that the screen refreshes
        dbData.id = this.props.wholeData.id;
        this.props.updateContactAction(dbData);
      }
    } else {
      this.setState({ active: true, errorMessage: strings.errorMessage });
    }
  }

  saveContactDataThrottled = () => {
    _.throttle(this.saveContactData(), 5000, { trailing: false });
  }
  radioButtonData = [
    {
      label: this.props.strings && this.props.strings.residence,
      value: '2'
    }, {
      label: this.props.strings && this.props.strings.business,
      value: '1'
    }
  ];
  options = [
    { value: '1', label: 'Home' },
    { value: '2', label: 'Business' },
    { value: '3', label: 'Additional No. (Cell)' }
  ];
  optionsEs = [
    { value: '1', label: 'Residencia' },
    { value: '2', label: 'Negocio' },
    { value: '3', label: 'Número adicional (celular)' }
  ];
  render() {
    const { strings } = this.props;
    return (
      <div className={styles.popupBody}>
        <div className={styles.mainFieldContainer}>
          <div className={styles.fieldContainers}>
            <div className={styles.inputContainerHolder}>
              <div className={styles.inputTextDiv} >
                <span className={styles.labelText}>
                  {strings.firstName}
                </span>
                <span className={styles.labelStar}>
                *
                </span>
                <Input
                  type="text"
                  name="First Name"
                  hint={strings.firstName}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.firstNameCallback}
                  value={this.state.firstNameValue}
                />
              </div>
              <div className={styles.inputTextDiv} >
                <span className={styles.labelText}>
                  {strings.lastName}
                </span>
                <Input
                  type="text"
                  name={'Last Name'}
                  hint={strings.lastName}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.lastNameCallback}
                  value={this.state.lastNameValue}
                />
              </div>
            </div>
          </div>
          <div className={styles.fieldContainersDropdown}>
            <div className={styles.phoneContainerHolder}>
              <div className={styles.inputTextDiv} >
                <span className={styles.labelText}>
                  {strings.phoneNumber}
                </span>
                <span className={styles.labelStar}>
                *
                </span>
                <Input
                  type="string"
                  name={'Phone Number'}
                  hint={strings.phoneNumber}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.phoneNumberAction}
                  value={this.state.phoneNumberValue}
                />
              </div>
            </div>
            <div className={styles.dropdownHolder}>
              <span className={styles.labelText}>
                {strings.type}
              </span>
              <span className={styles.labelStar}>
                *
              </span>
              <Dropdown
                auto
                source={this.props.currentLanguage === 'es' ? this.optionsEs : this.options}
                onChange={this.handleEditDropdownChange}
                theme={styles}
                value={this.state.editDropdownValue}
              />
            </div>
          </div>
          <div className={styles.fieldContainersDropdown}>
            <div className={styles.dropdownHolder}>
              <span className={styles.labelText}>
                {strings.language}
              </span>
              <Dropdown
                auto
                source={this.optionSetLanguage}
                onChange={this.handleLanguageChange}
                theme={styles}
                value={this.state.langindicator}
              />
            </div>
            <div className={styles.dropdownHolder} />
          </div>
          <div className={styles.fieldContainersRadio}>
            <span className={styles.labelText}>
              {strings.calltype}
            </span>
            <div className={styles.popupRadioInner}>
              <RadioButtonGroup
                name="editRadio"
                value={this.state.editRadioValue}
                themestyles={styles}
                radioStyle={styles.radioStyle}
                radioButtonName={'edit'}
                radioButtonData={this.radioButtonData}
                handleRadioChange={this.editRadioChange}
              />
            </div>
            <div className={styles.placeHolder} />
          </div>
          <div className={styles.addressfieldContainers}>
            <div className={styles.inputContainerHolderBig}>
              <div className={styles.inputTextDivBig} >
                <span className={styles.labelText}>
                  {strings.address}
                </span>
                <Input
                  type="text"
                  name={strings.address}
                  hint={strings.address}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.addressAction}
                  value={this.state.address}
                />
              </div>
            </div>
          </div>
          <div className={styles.addressfieldContainers}>
            <div className={styles.inputContainerHolderBig}>
              <div className={styles.inputTextDivBig} >
                <span className={styles.labelText}>
                  {strings.dOB}
                </span>
                <Input
                  type="text"
                  pattern="\d*"
                  name={'DOB'}
                  hint={strings.dOB}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.dobChangeAction}
                  value={this.state.DOB}
                />
              </div>
            </div>
          </div>
          <div className={styles.addressfieldContainers}>
            <div className={styles.inputContainerHolderBig}>
              <div className={styles.inputTextDivBig} >
                <span className={styles.labelText}>
                  {strings.primaryContact}
                </span>
                <Input
                  type="text"
                  name={'Primary Contact'}
                  hint={strings.primaryContact}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.pcChange}
                  value={this.state.pcname}
                />
              </div>
            </div>
          </div>
          <div className={styles.addressfieldContainers}>
            <div className={styles.inputContainerHolderBig}>
              <div className={styles.inputTextDivBig} >
                <span className={styles.labelText}>
                  {strings.emailAddress}
                </span>
                <Input
                  type="text"
                  name={'Email Address'}
                  hint={strings.emailAddress}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.emailChange}
                  value={this.state.emailaddress}
                />
              </div>
            </div>
          </div>
          <div className={styles.fieldContainers}>
            <div className={styles.inputContainerHolderBig}>
              <span className={styles.labelText}>
                {strings.zipCityState}
              </span>
              <div className={styles.inputHolderSmall}>
                <Input
                  type="number"
                  name={'Zip'}
                  hint={strings.zip}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.zipChangedAction}
                  value={this.state.zip}
                />
                <Input
                  type="text"
                  name={'City'}
                  hint={strings.city}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.cityChangedAction}
                  value={this.state.city}
                />
                <Input
                  type="text"
                  name={'State'}
                  hint={strings.state}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.stateChangedAction}
                  value={this.state.state}
                />
              </div>
            </div>
          </div>
          { (this.state.editRadioValue === '1') ? <div className={styles.fieldContainers}>
            <div className={styles.inputContainerHolderBig}>
              <div className={styles.inputTextDivBig} >
                <span className={styles.labelText}>
                  {strings.businessname}
                </span>
                <Input
                  type="text"
                  name={'Business Name'}
                  hint={strings.businessname}
                  display="flex"
                  theme={styles}
                  floating={false}
                  onChange={this.businessFirmAction}
                  value={this.state.businessFirmName}
                />
              </div>
            </div>
          </div> : null
          }
        </div>
        <div className={styles.saveDiv}>
          <div className={styles.buttonHolder}>
            <button
              className={styles.saveSpan}
              onMouseDown={() => this.saveContactDataThrottled()}
            >{strings.update}</button>
            <button
              className={styles.cancelSpan}
              onMouseDown={() => this.props.closeAction()}
            >{strings.cancel}</button>
          </div>
        </div>
        <Dialog
          actions={this.action(strings)}
          active={this.state.active}
          onEscKeyDown={this.handleToggle}
          onOverlayClick={this.handleToggle}
          className={styles.alertDialog}
        >
          <p>{this.state.errorMessage}</p>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetchContactData: state.popup.fetchContactData,
  picklistLanguage: state.manage.picklistLanguage
});
export default connect(mapStateToProps, actions)(PopupEdit);



// WEBPACK FOOTER //
// ./src/containers/PopupEdit/PopupEdit.js